import React, { FC } from 'react'

import { TermsProps } from './types'
import { TermsModalContent } from './TermsModalContent'

export type TermsOfSaleProps = TermsProps

export const TermsOfSale: FC<TermsOfSaleProps> = ({ open, setCurrentlyOpenTermsModal }) => {
  return (
    <TermsModalContent
      termsType={'termsOfSale'}
      open={open}
      setCurrentlyOpenTermsModal={setCurrentlyOpenTermsModal}
    />
  )
}
